export default "__VITE_ASSET__CeXLXapr__"